import Swiper from 'swiper'

export default class ProductStyledWith {
  constructor(component) {
    this.dom = {
      $component: component,
      $mainImage: component.querySelector('.js-productStyledWithImg')
    }
    this.state = {
      observer: null,
      loadedImgClass: 'loadedImg',
      supportsIntersectionObserver:  ('IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype)
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {state} = this

    if (state.supportsIntersectionObserver) {
      this.observe()
    } else {
      this.load()
    }
  }

  observe() {
    const {dom, state} = this
    state.observer = new IntersectionObserver(this.onIntersection.bind(this), {
      rootMargin: '250px'
    })
    state.observer.observe(dom.$mainImage)
  }

  onIntersection(entries) {
    const {state} = this
    const entry = entries[0]

    if (entry.isIntersecting) {
      this.load()
      state.observer.unobserve(entry.target)
    }
  }

  load() {
    const {dom, state} = this
    const src = dom.$mainImage.dataset.src
    const img = new Image()

    if (!src) return

    img.src = src
    img.addEventListener('load', () => {
      dom.$mainImage.src = src
      dom.$mainImage.classList.add(state.loadedImgClass)
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductRecommendations = this
  }
}
